import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { useMainContext } from "../../../Context";
import {
  buyPlan,
  checkOffer,
  editProfile,
  plans,
  userDashboard,
} from "../../../Utils/Apis";

export const useProfile = () => {
  const [form, setForm] = useState({});
  const [loading, setLoading] = useState({ edit: false });
  const navigate = useNavigate();

  const {
    post,
    state: { user },
    dispatch,
  } = useMainContext();
  const submit = async () => {
    setLoading({ edit: true });
    const { data, status } = await post(editProfile, form, true);
    if (+status == 200) {
      dispatch("user", { ...user, user: data });
    }
    setLoading({ edit: false });
  };
  const handler = (key, value) => {
    setForm({ ...form, [key]: value });
  };
  const updateImageProfile = async photo => {
    setLoading({ imageProfile: true });
    const { data, status } = await post(editProfile, { photo }, true);
    if (+status == 200) {
      dispatch("user", { ...user, user: data });
    }
    setLoading({ imageProfile: false });
  };

  return { loading, user, submit, handler, updateImageProfile, navigate };
};

export const useDashboard = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);

  const { post } = useMainContext();
  const get = async () => {
    setLoading(true);
    const { data } = await post(userDashboard, {});
    setData(data);
    setLoading(false);
  };
  useEffect(() => {
    get();
  }, []);

  return { data, loading };
};
export const usePlans = () => {
  const [data, setData] = useState({});
  const [loading, setLoading] = useState(true);
  const [loadingBtn, setLoadingBtn] = useState(false);
  const [selected, setSelected] = useState({});
  const [form, setForm] = useState({ status: false });
  const [loadingCheck, setLoadingCheck] = useState(false);
  const { post } = useMainContext();
  const get = async () => {
    setLoading(true);
    const { data } = await post(plans, {});
    setData(data);
    setLoading(false);
  };
  const buy = async () => {
    setLoadingBtn(true);
    let newObj = {};
    if (form.status) {
      newObj = { off_code: selected.off_code };
    }
    const { data, status } = await post(
      buyPlan,
      { plan_id: selected.id, ...newObj },
      true
    );
    if (+status == "200") {
      window.location.replace(data.url);
    }
    setLoadingBtn(false);
  };
  const check = async init => {
    setLoadingCheck(true);
    console.log("fuck", selected);
    const { data, status } = await post(
      checkOffer,
      {
        plan_id: selected.id,
        off_code: selected.off_code,
      },
      true
    );
    setForm({ ...data, status: true });
    setLoadingCheck(false);
  };
  useEffect(() => {
    get();
  }, []);

  return {
    data,
    loading,
    selected,
    setSelected,
    buy,
    loadingBtn,
    check,
    loadingCheck,
    form,
  };
};
